module.exports = __webpack_public_path__ + "static/lent_fishfry_menu-73ab0ebacfa23a4b489f8adb2f6de7a6.png";